import React from "react";
import getContainerSizeClass from "@root/helpers/get-container-size-class";
import getColorSanity from "@root/helpers/get-color-sanity";

const HorizontalDivider = ({ data }) => {
    const classes = getContainerSizeClass(data?.moduleSettings);
    const color = getColorSanity(data?.color) || "#000000";
    const spacing = data?.spacing || "medium";
    const spacingClass = `horizontal-divider--spacing-${spacing}`;

    return (
        <div className={`horizontal-divider ${spacingClass} ${classes.join(" ")}`}>
            <hr 
                className="horizontal-divider__line" 
                style={{ borderColor: color }}
            />
        </div>
    );
};

export default HorizontalDivider;

